import { FPageBlock, FPageContainerKind } from '../../mdl/f-page-block';
import { uiIsLightBG, uiSetBG } from '../../ui/bg';
import { UILabeled } from '../../ui/component/labeled';
import { UISelect } from '../../ui/component/select';
import { $el } from '../../ui/elements';
import { uiSetPrefixedClass } from '../../ui/functions';
import { UIValue } from '../../ui/types';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlockSpec } from '../block';
import { EDContainerBlock } from '../containerblock';
import { EDBlockContainer } from '../editor';
import { EDBackgroundInput } from '../image';
import { $page_values } from './values';

const container_kind_values: UIValue<FPageContainerKind>[] = [{ key: 'full', name: 'Full Width' }, { key: 'bottom', name: 'Bottom' }, { key: 'cards', name: 'Cards' }];

export const ed_page_container_block: EDBlockSpec<FPageBlock> = {
    key: 'container',
    editor_block: class extends EDContainerBlock<FPageBlock> {
        constructor(container: EDBlockContainer) {
            const kind = new UISelect(container_kind_values, { kind: 'k-subtle' });
            const bg = new EDBackgroundInput($page_values.bg_presets, 'page');
            const color_scheme = new UISelect($page_values.color_scheme, { kind: 'k-subtle' });

            const properties = $el.DIV('l-form', [
                new UILabeled(kind, { above: 'Kind' }),
                new UILabeled(bg, { above: 'Background' }),
                new UILabeled(color_scheme, { above: 'Color scheme' }),
            ]);

            super($form({ kind, bg, color_scheme }), container, 'Container', properties);
            this.classList.add('blk-container');
            this.list.classList.add('r-container');

            const background = $el.DIV('r-bg');

            $on(bg, 'change', () => {
                const v = bg.value || {};
                uiSetBG(background, v);
                const is_light = uiIsLightBG(v);
                const current = color_scheme.value;
                if(is_light === true) {
                    if(current != 'light' && current != 'lgreen')
                        color_scheme.value = 'light';
                } else if(is_light === false) {
                    if(current != 'dark' && current != 'green')
                        color_scheme.value = 'dark';
                } else {
                    color_scheme.value = 'inherit';
                }
            });

            $on(color_scheme, 'value', v => {
                this.classList.toggle('c-light', v == 'light');
                this.classList.toggle('c-dark', v == 'dark');
                this.classList.toggle('c-green', v == 'green');
                this.classList.toggle('c-lgreen', v == 'lgreen');
            });

            $on(kind, 'value', v => {
                uiSetPrefixedClass(this, 'k', v);
            });

            this.ui_add($el.DIV('r-content', [background, this.list]))
        }

        get selection_style() {
            return { radius: 33 };
        }

        get hover_style() {
            return { radius: 29 };
        }
    }
};
